/**
 * Replace escaped newline characters with actual newline characters so the markdown component renders them.
 * @param markdownString
 * @returns A markdown string with escaped newline characters replaced with actual newline characters.
 */
export const preserveNewlines = (markdownString: string) => {
    return markdownString.replace(/\\n/g, "\n");
};

/**
 * Preprocess the string to escape periods in numbered sequences that are likely not intended as markdown lists.
 * For example, "1234. hello" will become "1234\\. hello", preventing markdown from interpreting it as a list.
 * @param message The markdown string to preprocess.
 * @returns A preprocessed markdown string with large numbered sequences escaped.
 */
export const preprocessString = (message: string) => {
    return message.replace(/(^|\n)(\d+)\.(\s|$)/g, (match, p1, p2) => {
        // Only replace if the number is large enough to not be a common list item
        if (p2.length > 2) {
            return `${p1}${p2}\\. `;
        }
        return match;
    });
};
